<form-layout [showSave]="canSave" (onSave)="onSaveClick()" (onBack)="onBackClick()"
    (onNext)="onSaveAndNextClick()">

    <form [formGroup]="fragenStepForm">
        <section-info></section-info>
        <div *ngFor="let faFormGroup of sortedFragen; let i = index" class="mt-3">
            <p *ngIf="frageHeadline(faFormGroup.value) != ''" class="frage-headline" [trimRichtextAriaLabel]="frageHeadline(faFormGroup.value)" [innerHTMLBypassXSS]="frageHeadline(faFormGroup.value)"></p>
            <ng-container [formGroup]="faFormGroup">
                <input type="hidden" id="anfrageId" [value]="faFormGroup.value.answer.anfrageId" />

                <!-- Einzeiliges Textfeld -->
                <kendo-formfield class="text"
                    *ngIf="frageFeldTyp(faFormGroup.value) === fieldTypeEnum.Textfeldeinzeilig">
                    
                        <kendo-label class="form-label" [for]="'textEinzeilig_'+ i" [text]="frageText(faFormGroup.value)" [infotooltip]="'question' + faFormGroup.value.frageId">
                        </kendo-label>

                    <div formGroupName="answer">
                        <kendo-textbox type="text" formControlName="textEinzeilig" showSuccessIcon="initial"
                            showErrorIcon="initial" [id]="'textEinzeilig_'+ i"
                            [appinfotextfrage]="faFormGroup.value" preventEmptyFormatter [maxlength]="frageMaxLength(faFormGroup.value)">
                        </kendo-textbox>
                        <div [id]="'word-count-text-einzeilig'+ i">
                            <div class="ck ck-word-count">
                                <div class="ck-word-count__words" title="{{'wordcounter.words' | translate}}: {{frageWordCounter(faFormGroup.value)}}">{{"wordcounter.words" | translate}}: {{frageWordCounter(faFormGroup.value)}}</div>
                                <div *ngIf="isMaxVisible(faFormGroup.value)" title="{{'wordcounter.characters' | translate}}: {{frageCharacterCounter(faFormGroup.value)}}" class="ck-word-count__characters">{{"wordcounter.characters" | translate}}: {{frageCharacterCounter(faFormGroup.value)}} / {{faFormGroup.value.maxLength}}</div>
                                <div *ngIf="!isMaxVisible(faFormGroup.value)" title="{{'wordcounter.characters' | translate}}: {{frageCharacterCounter(faFormGroup.value)}}" class="ck-word-count__characters">{{"wordcounter.characters" | translate}}: {{frageCharacterCounter(faFormGroup.value)}}</div>
                            </div>
                        </div> 
                    </div>
                </kendo-formfield>

                <!-- Mehrzeiliges Textfeld -->
                <kendo-formfield class="text" *ngIf="frageFeldTyp(faFormGroup.value) === fieldTypeEnum.Textfeldmehrzeilig">
                    <kendo-label class="form-label" [for]="'text_'+ i" [text]="frageText(faFormGroup.value)"  [infotooltip]="'question' + faFormGroup.value.frageId"></kendo-label>
                    <div formGroupName="answer">
                        <ckeditor [id]="'text_'+ i" formControlName="text" [editor]="Editor" data=""
                            [config]="editorConfig" [appinfotextfrage]="faFormGroup.value" (ready)="initCKEditor($event, 'word-count-text_' + i, faFormGroup.value, i)">
                        </ckeditor>
                        <div [id]="'word-count-text_' + i"></div>
                    </div>
                </kendo-formfield>

                <!-- Ja / Nein -->
                <kendo-formfield class="text" *ngIf="frageFeldTyp(faFormGroup.value) === fieldTypeEnum.JaNein">
                    <kendo-label class="form-label" [for]="'ja_'+ i" [text]="frageText(faFormGroup.value)"  [infotooltip]="'question' + faFormGroup.value.frageId"></kendo-label>
                    <div formGroupName="answer">
                        <div class="d-flex">
                            <ul class="k-radio-list" tabindex="0">
                                <li class="k-radio-item">
                                    <input
                                        [id]="'ja_'+ i"
                                        type="radio"
                                        tabindex="0"
                                        kendoRadioButton
                                        formControlName="jaNein"
                                        [value]="true"
                                        [appinfotextfrage]="faFormGroup.value" />
                                    <kendo-label class="form-label" [for]="'ja_'+ i" text="{{'question.yes' | translate}}"></kendo-label>
                                </li>

                                <li class="k-radio-item">
                                    <input
                                        [id]="'nein_'+ i"
                                        kendoRadioButton
                                        tabindex="0"
                                        formControlName="jaNein"
                                        type="radio"
                                        [value]="false"
                                        [appinfotextfrage]="faFormGroup.value" />
                                    <kendo-label class="form-label" [for]="'nein_'+ i" text="{{'question.no'| translate}}"></kendo-label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </kendo-formfield>

                <!-- Ja / Nein mit Beschreibung -->
                <kendo-formfield class="text" showHints="initial" *ngIf="frageFeldTyp(faFormGroup.value) === fieldTypeEnum.JaNeinmitBeschreibung">
                    <kendo-label class="form-label" [text]="frageText(faFormGroup.value)" [infotooltip]="'question' + faFormGroup.value.frageId"></kendo-label>
                    <div formGroupName="answer">
                        <div class="d-flex">
                            <ul class="k-radio-list">
                                <li class="k-radio-item">
                                    <input
                                        [id]="'janein_begr_ja_'+ i"
                                        type="radio"
                                        tabindex="0"
                                        kendoRadioButton
                                        formControlName="jaNein"
                                        [value]="true"
                                        [appinfotextfrage]="faFormGroup.value" />
                                    <kendo-label class="form-label" [for]="'janein_begr_ja_'+ i" text="{{'question.yes' | translate}}">
                                    </kendo-label>
                                </li>

                                <li class="k-radio-item">
                                    <input
                                        [id]="'janein_begr_nein_'+ i"
                                        type="radio"
                                        tabindex="0"
                                        kendoRadioButton
                                        formControlName="jaNein"
                                        [value]="false"
                                        [appinfotextfrage]="faFormGroup.value" />
                                    <kendo-label class="form-label" [for]="'janein_begr_nein_'+ i" text="{{'question.no' | translate}}">
                                    </kendo-label>
                                </li>
                            </ul>
                        </div>

                        <ckeditor #text formControlName="text" [editor]="Editor" data="" [config]="editorConfig"
                            [appinfotextfrage]="faFormGroup.value"                             (ready)="initCKEditor($event, 'word-count-ja-nein-beschreibung' + i, faFormGroup.value, i)">
                        </ckeditor>
                        <div [id]="'word-count-ja-nein-beschreibung'+ i"></div>                        
                    </div>
                </kendo-formfield>

                <!-- Ja mit Beschreibung -->
                <kendo-formfield class="text" showHints="initial"
                    *ngIf="frageFeldTyp(faFormGroup.value) === fieldTypeEnum.JamitBeschreibung">
                    <kendo-label class="form-label" [text]="frageText(faFormGroup.value)" [infotooltip]="'question' + faFormGroup.value.frageId"></kendo-label>
                    <div formGroupName="answer">
                        <div class="d-flex">
                            <ul class="k-radio-list">
                                <li class="k-radio-item">
                                    <input
                                        [id]="'jan_begr_ja_'+ i"
                                        tabindex="0"
                                        kendoRadioButton
                                        type="radio"
                                        formControlName="jaNein"
                                        [value]="true"
                                        [appinfotextfrage]="faFormGroup.value" />
                                    <kendo-label class="form-label" [for]="'ja_begr_ja_'+ i" text="{{'question.yes' | translate}}">
                                    </kendo-label>
                                </li>

                                <li class="k-radio-item">
                                    <input
                                        [id]="'ja_begr_nein_'+ i"
                                        tabindex="0"
                                        kendoRadioButton
                                        type="radio"
                                        formControlName="jaNein"
                                        [value]="false"
                                        [appinfotextfrage]="faFormGroup.value" />
                                    <kendo-label class="form-label" [for]="'ja_begr_nein_'+ i" text="{{'question.no' | translate}}">
                                    </kendo-label>
                                </li>
                            </ul>
                        </div>

                        <ckeditor *ngIf="faFormGroup.value.answer.jaNein == true" #text formControlName="text"
                            [editor]="Editor" data="" [config]="editorConfig" [appinfotextfrage]="faFormGroup.value"
                            (ready)="initCKEditor($event, 'word-count-ja-beschreibung' + i, faFormGroup.value, i)">
                        </ckeditor>
                        <div [id]="'word-count-ja-beschreibung'+ i"></div>
                    </div>
                </kendo-formfield>

                <!-- Nein mit Beschreibung -->
                <kendo-formfield class="text" showHints="initial"
                    *ngIf="frageFeldTyp(faFormGroup.value) === fieldTypeEnum.NeinmitBeschreibung">
                    <kendo-label class="form-label" [text]="frageText(faFormGroup.value)"[infotooltip]="'question' + faFormGroup.value.frageId">
                    </kendo-label>

                    <div formGroupName="answer">
                        <div class="d-flex">
                            <ul class="k-radio-list">
                                <li class="k-radio-item">
                                    <input
                                        [id]="'nein_begr_ja_'+ i"
                                        type="radio"
                                        tabindex="0"
                                        kendoRadioButton
                                        formControlName="jaNein"
                                        [value]="true"
                                        [appinfotextfrage]="faFormGroup.value" />
                                    <kendo-label class="form-label" [for]="'nein_begr_ja_'+ i" text="{{'question.yes' | translate}}">
                                    </kendo-label>
                                </li>

                                <li class="k-radio-item">
                                    <input
                                        [id]="'nein_begr_nein_'+ i"
                                        type="radio"
                                        tabindex="0"
                                        kendoRadioButton
                                        formControlName="jaNein"
                                        [value]="false"
                                        [appinfotextfrage]="faFormGroup.value" />
                                    <kendo-label class="form-label" [for]="'nein_begr_nein_'+ i" text="{{'question.no' | translate}}">
                                    </kendo-label>
                                </li>
                            </ul>
                        </div>

                        <ckeditor *ngIf="faFormGroup.value.answer.jaNein == false" #text formControlName="text"
                            [editor]="Editor" data="" [config]="editorConfig" [appinfotextfrage]="faFormGroup.value"
                            (ready)="initCKEditor($event, 'word-count-nein-beschreibung' + i, faFormGroup.value, i)">
                        </ckeditor>
                        <div [id]="'word-count-nein-beschreibung'+ i"></div>
                    </div>
                </kendo-formfield>

                <!-- Datum -->
                <kendo-formfield class="text" *ngIf="frageFeldTyp(faFormGroup.value) === fieldTypeEnum.Datum">
                    <kendo-label class="form-label" [for]="datum" [text]="frageText(faFormGroup.value)"[infotooltip]="'question' + faFormGroup.value.frageId">
                    </kendo-label>
                    <div formGroupName="answer" class="quarter-width">
                        <kendo-datepicker #datum 
                            (valueChange)="onDatumChange(faFormGroup.value, $event)"
                            formControlName="datum" 
                            [appinfotextfrage]="faFormGroup.value"
                            [format]="dateFormat"
                            [incompleteDateValidation]="true">
                        </kendo-datepicker>
                    </div>
                </kendo-formfield>

                <!-- Währung -->
                <kendo-formfield class="text" *ngIf="frageFeldTyp(faFormGroup.value) === fieldTypeEnum.Wahrung">
                    <kendo-label class="form-label" [for]="waehrung" [text]="frageText(faFormGroup.value)" [infotooltip]="'question' + faFormGroup.value.frageId">
                    </kendo-label>
                    <div formGroupName="answer" class="quarter-width">
                        <kendo-numerictextbox #waehrung formControlName="waehrung" [autoCorrect]="true" [min]="0" [format]="currencyFormatOptions" [decimals]="2"
                            [appinfotextfrage]="faFormGroup.value" [max]="highestPossibleValue(faFormGroup.value)">
                        </kendo-numerictextbox>
                    </div>
                </kendo-formfield>

                <!-- Ganze Zahl -->
                <kendo-formfield class="text" *ngIf="frageFeldTyp(faFormGroup.value) === fieldTypeEnum.GanzeZahl">
                    <kendo-label class="form-label" [for]="ganzezahl" [text]="frageText(faFormGroup.value)" [infotooltip]="'question' + faFormGroup.value.frageId">
                    </kendo-label>

                    <div formGroupName="answer" class="quarter-width">
                        <kendo-numerictextbox #ganzezahl formControlName="ganzezahl" [autoCorrect]="false" [min]="0" format="n0" [decimals]="0"
                            [appinfotextfrage]="faFormGroup.value" [maxlength]="frageMaxLength(faFormGroup.value)" [max]="highestPossibleIntValue(faFormGroup.value)">
                        </kendo-numerictextbox>
                    </div>
                </kendo-formfield>

                <!-- Dezimal Zahl -->
                <kendo-formfield class="text" *ngIf="frageFeldTyp(faFormGroup.value) === fieldTypeEnum.Dezimalzahl">
                    <kendo-label class="form-label" [for]="dezimalzahl" [text]="frageText(faFormGroup.value)" [infotooltip]="'question' + faFormGroup.value.frageId">
                    </kendo-label>

                    <div formGroupName="answer" class="quarter-width">
                        <kendo-numerictextbox #dezimalzahl formControlName="dezimalzahl" [autoCorrect]="true" [min]="0" format="n2" [decimals]="2"
                            [appinfotextfrage]="faFormGroup.value" [max]="highestPossibleValue(faFormGroup.value)">
                        </kendo-numerictextbox>
                    </div>
                </kendo-formfield>

                <!-- Auswahl -->
                <kendo-formfield class="text" *ngIf="frageFeldTyp(faFormGroup.value) === fieldTypeEnum.Auswahl">
                    <kendo-label class="form-label" [for]="auswahl" [text]="frageText(faFormGroup.value)" [infotooltip]="'question' + faFormGroup.value.frageId">
                    </kendo-label>
                    <div formGroupName="answer" class="half-width">
                        <kendo-combobox formControlName="auswahl" #auswahl [valueField]="'Value'" [textField]="'Description'" [valuePrimitive]="false"
                        [allowCustom]="false" [appinfotextfrage]="faFormGroup.value" kendoDropDownFilter [data]="auswahlOptionen.get(faFormGroup.value.frageId) ?? []">
                        </kendo-combobox>
                    </div>
                </kendo-formfield>

                <!-- Mehrfachauswahl -->
                <kendo-formfield class="text" *ngIf="frageFeldTyp(faFormGroup.value) === fieldTypeEnum.Mehrfachauswahl">
                    <kendo-label class="form-label" [for]="auswahl" [text]="frageText(faFormGroup.value)" [infotooltip]="'question' + faFormGroup.value.frageId">
                    </kendo-label>
                    <div formGroupName="answer" class="half-width">
                        <kendo-multiselect formControlName="mehrfachAuswahl" #auswahl [valueField]="'Value'" [textField]="'Description'" [valuePrimitive]="false"
                        [allowCustom]="false" [appinfotextfrage]="faFormGroup.value" kendoDropDownFilter [data]="auswahlOptionen.get(faFormGroup.value.frageId) ?? []">
                        </kendo-multiselect>
                    </div>
                </kendo-formfield>
            </ng-container>
        </div>
    </form>